import { SET_DATA_MAP } from "../constants";

export const setDataMap = (dataMap) => ({
	type: SET_DATA_MAP,
	payload: dataMap,
});
